import React, { useState, useEffect } from 'react';
import api from '../api/api';
import {
  Box,
  Typography,
  CircularProgress,
  Grid,
  Card,
  CardContent,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper
} from '@mui/material';

export default function ApiUsage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await api.get('/api-usage/summary');
        setData(res.data);
      } catch (err) {
        setError('No se pudo cargar datos');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" mt={4}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box mt={4} textAlign="center">
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  const {
    total_requests: total,
    by_tenant: tenants,
    top_endpoints: endpoints,
    avg_response_ms: avgMs
  } = data;

  return (
    <Box p={3}>
      <Typography variant="h4" gutterBottom>
        Uso de API
      </Typography>

      <Grid container spacing={2} mb={3}>
        <Grid item xs={12} sm={4}>
          <Card>
            <CardContent>
              <Typography variant="h6">Total de peticiones</Typography>
              <Typography variant="h3">{total}</Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Box mb={3}>
        <Typography variant="h6" gutterBottom>
          Peticiones por Tenant
        </Typography>
        <Paper>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Tenant</TableCell>
                <TableCell align="right">Peticiones</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tenants.map(t => (
                <TableRow key={t.tenant_id}>
                  <TableCell>{t.tenant_name || t.tenant_id}</TableCell>
                  <TableCell align="right">{t.total_requests}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      </Box>

      <Box mb={3}>
        <Typography variant="h6" gutterBottom>
          Top Endpoints
        </Typography>
        <Paper>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Ruta</TableCell>
                <TableCell align="right">Hits</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {endpoints.map(e => (
                <TableRow key={e.path}>
                  <TableCell>{e.path}</TableCell>
                  <TableCell align="right">{e.hits}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      </Box>

      <Box>
        <Typography variant="h6" gutterBottom>
          Tiempos promedio (ms)
        </Typography>
        <Paper>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Ruta</TableCell>
                <TableCell align="right">Avg ms</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {avgMs.map(a => (
                <TableRow key={a.path}>
                  <TableCell>{a.path}</TableCell>
                  <TableCell align="right">{a.avg_ms}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      </Box>
    </Box>
  );
}
